import React , {useEffect} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import baseUrl from '../../../base_url';
import axios from 'axios';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Helper function to determine if a route is active
  const isActive = (path) => {
    return location.pathname.includes(path);
  };

  useEffect(() => {
    const getUser = async() => {
      try {
        await axios.get(`${baseUrl}api/admin/checkLogin`, { withCredentials: true });
      } catch(err) {
        console.log("error while checking if logged in");
        console.log(err);
        navigate("/admin/login");
      }
    };
    getUser();
  }, [navigate, baseUrl]);
  
  // Function to handle logout
  const handleLogout = async () => {
    try {
      await axios.post(`${baseUrl}api/admin/logout`, {}, { withCredentials: true });
      localStorage.removeItem("adminToken")
      navigate("/admin/login");
    } catch(err) {
      console.log("error while logging out");
      console.log(err);
      navigate("/admin/login");
    }
  };
  
  const menuItems = [
    {
      name: 'Home',
      path: '/admin/dashboard',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
          <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
        </svg>
      )
    },
    {
      name: 'Orders',
      path: '/admin/orders',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
          <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
        </svg>
      )
    },
    {
      name: 'Returns',
      path: '/admin/returns',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M3.172 7l5.536-5.536a.75.75 0 011.06 1.06L5.81 7h8.44a5 5 0 110 10H6a.75.75 0 010-1.5h8.25a3.5 3.5 0 100-7H8.81l3.958 3.958a.75.75 0 11-1.06 1.06L3.172 7z" clipRule="evenodd" />
        </svg>
      )
    },
    {
      name: 'Products',
      path: '/admin/products',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd" />
        </svg>
      )
    },
    {
      name: 'Customers',
      path: '/admin/customers',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
          <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
        </svg>
      )
    },
    // {
    //   name: 'Discounts',
    //   path: '/admin/discounts',
    //   icon: (
    //     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
    //       <path fillRule="evenodd" d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
    //     </svg>
    //   )
    // }
  ];

  return (
    <div className="w-64 bg-white shadow-md flex flex-col h-full">
      <div className="p-4 bg-blue-900 text-white">
        <div className="flex items-center">
          <div className="mr-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <path d="M22 6l-10 7L2 6" />
            </svg>
          </div>
          <div>
            <h1 className="font-bold text-xl">Ju<span className="text-yellow-400">texx</span></h1>
            <p className="text-xs">QUALITY PRODUCTS</p>
          </div>
        </div>
      </div>
      <nav className="mt-4 flex-1">
        <ul>
          {menuItems.map((item) => (
            <li key={item.name}>
              <a 
                className={`px-6 py-3 flex items-center hover:bg-gray-100 cursor-pointer ${isActive(item.path) ? 'bg-blue-50' : ''}`}
                href={item.path}
              >
                {item.icon}
                <span>{item.name}</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>
      
      {/* Logout button at the bottom */}
      <div className="p-4 border-t">
        <button 
          onClick={handleLogout}
          className="w-full px-6 py-3 flex items-center justify-center bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;